// src/pages/SettingsPage.js
import { useState } from 'react';
import { ConnectionGroup } from '../../components/dashboard/ConnectionGroup.jsx';
import {
  ChevronUp,
  ChevronDown } from
'lucide-react';
import { useNavigate } from 'react-router-dom';

const styles = `
  /* Section Header */
.section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 16px 16px;
  background: #c1ecf8;
  border: none;  
  border-radius: 6px;
  cursor: pointer;
}

.section-header h2 {
  font-size: 18px;
  font-weight: 600;
  color: #111827;
}

/* Connections Grid */
.connections-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 25px 25px;
  margin-top: 16px;
}

@media (max-width: 1024px) {
  .connections-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .connections-grid {
    grid-template-columns: 1fr;
  }
}

`;

// CSS Style component
const SettingStyles = () => <style>{styles}</style>;

function SectionHeader({ title, isOpen, onToggle }) {
  return (
    <button onClick={onToggle} className="section-header">
      <h2>{title}</h2>
      {isOpen ? <ChevronUp /> : <ChevronDown />}
    </button>);

}


const connectionData = {
  utilisateur: [
  { label: 'Utilisateurs', count: 1, path: '/admin/users' },
  { label: 'Roles', path: '/admin/roles' },
  { label: 'Permissions', path: '/admin/permissions' }],

  entite: [
  { label: 'Entités', path: '/admin/entities' },
  { label: 'Agences', path: '/admin/agencies' },
  { label: 'Garages aggréés', path: '/admin/garages' }],

  lifecycle: [
  { label: 'Blog', path: '/admin/blogs' },
  { label: 'FAQ', path: '/admin/faqs' },
  { label: 'Forum', path: '/admin/forum' }],

  produit: [
  { label: 'Produits', path: '/admin/products' }],

  shift: [
  { label: 'Categories', path: '/admin/categories' },
  { label: 'Tags', path: '/admin/tags' }],

  expense: [
  { label: 'Expense Claim', path: '/admin/expense-claim' },
  { label: 'Employee Advance', path: '/admin/employee-advance' }],

  benefit: [
  { label: 'Employee Benefit Application', path: '/admin/employee-benefit-application' }],

  payroll: [
  { label: 'Salary Structure Assignment', path: '/admin/salary-structure-assignment' }],

  evaluation: [
  { label: 'Appraisal', path: '/admin/appraisal' }]

};

function ConnectionsContent({ sectionsOpen, toggleSection, navigate, path }) {
  return (
    <div>
      <SettingStyles />
      <div>
        <SectionHeader
          title="Paramètres de l'application"
          isOpen={sectionsOpen.connections}
          onToggle={() => toggleSection('connections')} />

        {sectionsOpen.connections &&
        <div className="connections-grid">
            <ConnectionGroup title="Utilisateurs" items={connectionData.utilisateur} navigate={navigate} path={path} />
            <ConnectionGroup title="Entités" items={connectionData.entite} navigate={navigate} path={path} />
            <ConnectionGroup title="Lifecycle" items={connectionData.lifecycle} navigate={navigate} path={path} />
            <ConnectionGroup title="Produits" items={connectionData.produit} navigate={navigate} path={path} />
            <ConnectionGroup title="Parametres" items={connectionData.shift} navigate={navigate} path={path} />
            <ConnectionGroup title="Expense" items={connectionData.expense} navigate={navigate} path={path} />
            <ConnectionGroup title="Benefit" items={connectionData.benefit} navigate={navigate} path={path} />
            <ConnectionGroup title="Payroll" items={connectionData.payroll} navigate={navigate} path={path} />
            <ConnectionGroup title="Evaluation" items={connectionData.evaluation} navigate={navigate} path={path} />
          </div>
        }
      </div>
    </div>);

}

const SettingsPage = () => {

  const [sectionsOpen, setSectionsOpen] = useState({
      activity: true,
      connections: true
    });
  
    const toggleSection = (section) => {
      setSectionsOpen((prev) => ({
        ...prev,
        [section]: !prev[section]
      }));
    };
    const navigate = useNavigate();

  return (
    <div className="settings-page" style={{marginLeft: '20px', marginRight: '20px', minHeight: '100vh', backgroundColor: '#ffffff', display: 'flex', flexDirection: 'column',padding: '20px', borderRadius: '8px', boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'}}>
      <ConnectionsContent sectionsOpen={sectionsOpen} toggleSection={toggleSection} navigate={navigate} />;
    </div>
  );
};

export default SettingsPage;